import jsPDF from "jspdf";
import "jspdf-autotable";
import * as style from './ReportStyle'

var pageHeder = function (doc, dateRange) {
    style.pageBorder(doc);
    style.pageHeder(doc);
    style.reportHeder3(doc, dateRange);
};

function reportBody(doc, schemes, dateRange) {
    style.tableBody(doc, schemes, dateRange);
}

function pageFooter(doc) {
    style.pageFooter(doc);
}

const schemeMasterReport = (data) => {
    const schemes = Array.isArray(data) ? data : [data];
    if (schemes.length === 0) return;

    // ⭐ read the exact dates the user picked, no saga changes required
    let dateRange = {};
    try {
        dateRange = JSON.parse(sessionStorage.getItem("SchemeReportDateRange")) || {};
    } catch (e) { }

    let doc = new jsPDF('p', 'pt', 'a4');

    pageHeder(doc, dateRange);
    reportBody(doc, schemes, dateRange);
    pageFooter(doc);

    doc.setProperties({ title: `SchemeMasterReport` });

    function generateSaveAndOpenPDFReport() {
        const pdfUrl = URL.createObjectURL(doc.output('blob'));
        window.open(pdfUrl);
    }
    generateSaveAndOpenPDFReport();
}

export default schemeMasterReport;